import {
    GETREFUNDPARTNER_SUCCESS,
    GETREFUNDPARTNER_FAILED,
    RESET_GETREFUNDPARTNER,
    LOADING_GETREFUNDPARTNER,
    NETWORK_ERROR_GETREFUNDPARTNER,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {

    switch (action.type) {
        case LOADING_GETREFUNDPARTNER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETREFUNDPARTNER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETREFUNDPARTNER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_GETREFUNDPARTNER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETREFUNDPARTNER:
            return (state = initialState);
        default:
            return state;
    }
};
